// extracted by mini-css-extract-plugin
export default {"point":"Point_point__AwVUW"};